module.exports = __webpack_public_path__ + "img/sparking-change-analyze.90c8fe28.png";